import { Address } from '@ton/core'
import { BoxCollectionV0 } from '@voteboxio/core'
import { useAsyncInitialize } from './useAsyncInitialize'
import { useContactAddresses } from './useContactAddresses'
import { useTonClient } from './useTonClient'
import { useTonConnect } from './useTonConnect'

export function useInitializeContracts() {
  const { client } = useTonClient()
  const { wallet, sender } = useTonConnect()
  const { activeBoxCollectionContractAddress } = useContactAddresses()

  const boxCollection = useAsyncInitialize(async () => {
    if (!client || !activeBoxCollectionContractAddress) {
      return
    }

    const address = Address.parse(activeBoxCollectionContractAddress)

    const contract = BoxCollectionV0.BoxCollectionV0.fromAddress(address)

    return client.open(contract)
  }, [client, wallet, activeBoxCollectionContractAddress])

  if (!client || !boxCollection) {
    return
  }

  return {
    client,
    wallet,
    sender,
    boxCollection,
  }
}
